import axios from "axios";
import { GETCLIENTKEY } from "../index";

export const getClientKeyData = (postData) => {
  return axios.post(GETCLIENTKEY, JSON.stringify(postData));
};